module.exports = __webpack_public_path__ + "static/media/Sharp 31.5 R-IGZO Low-Power Performance.face055d.png";